import { render, staticRenderFns } from "./QuizListPage.vue?vue&type=template&id=165824c2"
import script from "./QuizListPage.vue?vue&type=script&lang=js"
export * from "./QuizListPage.vue?vue&type=script&lang=js"
import style0 from "./QuizListPage.vue?vue&type=style&index=0&id=165824c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports